import { ApiClientProps } from "hooks/useApi";
import { NotificationProps } from "../context/NotificationsContext";


export interface GetReservationListReportParams {
    requestId: string;

    format?: "json" | "csv";
    accessToken: string | undefined;
    apiClient: ApiClientProps;
    notify: (notification: NotificationProps) => void
}

async function getReservationListReport({
  requestId,
  format = "json",
  accessToken,
  apiClient,
  notify
}: GetReservationListReportParams) {
    if (!requestId) throw new Error("requestId is required");
    if (!accessToken) throw new Error("No accessToken provided");
    const basePath =
        "/middleware-admin/partners/report/get/checkmatch/report/reservation/list/" +
        encodeURIComponent(requestId);
    try {
        if (format === "csv") {

            const path = `${basePath}?format=csv`;
            const blob: Blob = await apiClient.get({
              path,
              headers: { Authorization: `Bearer ${accessToken}` },
              noRetry: true,
              responseType: "blob",
            });

            if (blob != null) {

                notify({
                  type: "success",
                  message: "Checkmatch Resevations Report download started successfully!",
                });

                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `checkmatch-reservations-report-${requestId}.csv`;
                a.click();
                URL.revokeObjectURL(url);
                return undefined;
            } else {
                notify({
                  type: "error",
                  message:
                        "Checkmatch Reservations Report generation failed. Please try again.",
                });
            }
        }

        const path = `${basePath}?format=json`;
        const response: any = await apiClient.get({
          path,
          headers: { Authorization: `Bearer ${accessToken}` },
          noRetry: true,
        });

        if (response && response.status === 200) {
            notify({
              type: "success",
              message: "Checkmatch Resevations Report download started successfully!",
            });
            return response;
        } else {
            notify({
              type: "error",
              message:
                    "Checkmatch Reservations Report generation failed. Please try again.",
            });
            return undefined;
        }

    } catch (e) {
        notify({
          type: "error",
          message:
                "Checkmatch Reservations Report generation failed. Please try again.",
        });
    }
}

export default getReservationListReport;
